export default __webpack_public_path__ + "media/zurb/img/party/15-218163391c53d21fa93c7ac189edeb94.jpg";